// extracted by mini-css-extract-plugin
module.exports = {"hero":"style_hero__CAS46","black":"style_black__gCcok","containImage":"style_containImage__xVhS0"};